import { metadata } from "./metadata.js";
import { assign } from "@pnp/common";
/**
 * Creates an object representing a SharePoint Collection(SP.KeyValue)
 *
 * @param obj The plain object defining the properties
 */
export function objectToSPKeyValueCollection(obj) {
    return assign(metadata("Collection(SP.KeyValue)"), {
        results: Object.keys(obj).map(function (key) { return assign(metadata("SP.KeyValue"), {
            Key: key,
            Value: Reflect.get(obj, key),
            ValueType: "Edm.String",
        }); }),
    });
}
//# sourceMappingURL=objectToSPKeyValueCollection.js.map